import axios from 'axios';

const eventApi = axios.create({
	baseURL: process.env.REACT_APP_EVENT_URL,
});

eventApi.interceptors.request.use(config => {
	config.headers['Content-Type'] = 'application/json';
	config.headers['tenant_id'] = process.env.REACT_APP_TENANT_ID;
	return config;
});

export {
    eventApi
};
